// LaunchRemedy theme — minimal client JS
(function(){
  // Cart count refresh
  async function refreshCart(){
    try{
      const r = await fetch('/cart.js',{headers:{Accept:'application/json'}});
      const c = await r.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+c.item_count+')');
    }catch(e){}
  }
  refreshCart();

  /*
    Add-to-cart submits are handled in assets/cart-drawer.js, which ajax-adds and
    then opens the shared cart drawer. The previous opt-in `data-ajax` submit
    handler lived here; it was removed so there is exactly one add-to-cart
    handler in the theme (no `data-ajax` form exists anywhere in it).
  */

  // PDP gallery
  document.querySelectorAll('[data-gallery]').forEach(g=>{
    const main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach((t,i)=>{
      t.addEventListener('click',()=>{
        g.querySelectorAll('[data-gallery-thumb]').forEach(x=>x.classList.remove('is-active'));
        t.classList.add('is-active');
        main.innerHTML = '<img src="'+t.dataset.src+'" alt="'+(t.dataset.alt||'')+'">';
      });
    });
  });

  // Simple homepage tabs (server-rendered blocks toggle by data-tab)
  document.querySelectorAll('[data-tabs]').forEach(root=>{
    const btns = root.querySelectorAll('[data-tab]');
    const panels = root.querySelectorAll('[data-panel]');
    btns.forEach(b=>b.addEventListener('click',()=>{
      btns.forEach(x=>x.classList.remove('is-active'));
      b.classList.add('is-active');
      panels.forEach(p=>p.hidden = p.dataset.panel !== b.dataset.tab);
    }));
  });
})();
